import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';

import LinksTo from 'ember-route-state/components/links-to.gjs';

import ErrorContact from 'rise-ui/components/error-contact.gjs';
import ErrorPage from 'rise-ui/components/error-page.gjs';

export default RouteTemplate(class CatalogRecordErrorTemplate extends Component {
  <template>
    <ErrorPage class="qa-error-record-not-found" as | error |>
      <error.title>Catalog Record Not Found</error.title>
      <error.subtitle>
        We're sorry, but that catalog record could not be found.
        <strong>
          Please return to the <LinksTo @route="catalog">catalog</LinksTo>
          to search for the record.
        </strong>
      </error.subtitle>
      <error.content><ErrorContact/></error.content>
    </ErrorPage>
  </template>
});
